import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
} from "reactstrap"
import { map } from "lodash"
import { withTranslation } from "react-i18next"

//i18n
import i18n from "i18n"
import languages from "common/languages"

const LanguageDropdown = () => {
	// Declare a new state variable, which we'll call "menu"
	const [selectedLang, setSelectedLang] = useState("")
	const [menu, setMenu] = useState(false)
	const { t } = useTranslation()

	function changeLanguageAction(lang) {
		//set language as i18n
		i18n.changeLanguage(lang)
		localStorage.setItem("lang", lang)
		localStorage.setItem("I18N_LANGUAGE", lang)
		setSelectedLang(lang)
		window.location.reload();
	}

	const toggle = () => {
		setMenu(!menu)
	}

	function getCurrentLocaleData() {
		const locale = i18n.language
		if (locale === 'ru') return "russian"
		else if (locale === 'uz_latn') { return "uzbek_latn" }
		else if (locale === 'uz_cyrl') { return "uzbek_cyrl" }
		else if (locale === 'tr') { return "turkish" }
	}

	useEffect(() => {
		const currentLanguage = localStorage.getItem("I18N_LANGUAGE")
		setSelectedLang(currentLanguage)
	}, [])

	return (
		<>
			<Dropdown isOpen={menu} toggle={toggle} className="d-inline-block language-switch">
				<DropdownToggle className="btn header-item waves-effect" tag="button">
					<i className="uil uil-globe"></i>
					{t(getCurrentLocaleData())}
				</DropdownToggle>
				<DropdownMenu className="dropdown-menu-end" right style={{ 'top': '3px!importnat' }}>
					{map(Object.keys(languages), key => (
						<DropdownItem
							key={key}
							onClick={() => changeLanguageAction(languages[key]['label'])}
							className={`lang-item notify-item ${selectedLang === key ? "active" : "none"
								}`}>
							<span className="align-middle">
								{t(languages[key]['i18n'])}
							</span>
						</DropdownItem>
					))}
				</DropdownMenu>
			</Dropdown>
		</>
	)
}

export default withTranslation()(LanguageDropdown)
